import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './activity.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Activity } from "model/promotion/activity.model";

export interface ActivityDetailsProps extends DetailsStateAndDispatchProps<Activity,'promotionStatus'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ActivityDetails: FC<ActivityDetailsProps> = (props) => {
  return (
    <DetailsPage<Activity,'promotionStatus'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Activity>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ activity }: RootState) => ({
  entity: activity.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ActivityDetails);
